export const sxConfig = {
  page: {
    minHeight: 'calc(100vh - 65px)',
    backgroundColor: {
      xs: '#fff',
      md: '#e9f3fc',
    },
    px: {
      xs: 1.5,
      md: 3,
    },
    pt: 2.5,
  },

  cardGridItem: {
    width: {
      xs: '100%',
      md: 350,
    },
    flexBasis: {
      xs: '100%',
      md: 350,
    },
    maxWidth: {
      xs: '100%',
      md: 350,
    },
  },

  card: {
    width: '100%',
    px: {
      xs: 1,
      md: 2,
    },
    boxSizing: 'border-box',
    border: {
      xs: '2px solid #BFE9D2',
      md: '4px solid #16a34a',
    },
    borderRadius: 4,
    backgroundColor: {
      xs: '#effaf3',
      md: '#d8f4f8',
    },
    color: {
      xs: '#000',
      md: '#16a34a',
    },
    cursor: 'pointer',

    display: 'flex',
    flexDirection: {
      xs: 'column-reverse',
      md: 'column',
    },
    alignItems: 'center',
    justifyContent: 'center',

    textAlign: 'center',
    transition: 'transform 300ms ease-in-out, background-color 300ms ease-in-out',

    '@media (hover: hover)': {
      '&:hover': {
        backgroundColor: '#bbf7d0',
        transform: 'translateY(-4px) scale(1.05)',
      },
    },
  },

  todoIcon: {
    fontSize: {
      xs: '2.5rem',
      md: '3rem',
    },
    color: '#0fbd1d',
  },

  todoTitle: {
    fontSize: {
      xs: '1.25rem',
      md: '1.5rem',
    },
  },

  menuTitle: {
    mb: {
      xs: 0,
      md: 1,
    },
    width: '100%',
    fontSize: {
      xs: '1.25rem',
      md: '1.5rem',
    },
    fontWeight: 700,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  todoCountBadge: {
    minWidth: 24,
    height: 24,
    px: 0.75,
    borderRadius: 12,
    bgcolor: 'warning.main',
    color: 'white',
    fontSize: '0.9rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
  },

  menuIconButton: {
    m: 0,
    p: 0,
    color: 'inherit',
    pointerEvents: 'none',
    mb: {
      xs: 1,
      md: 0,
    },
  },
};
